import type { SortOrderType } from '#types';

export type NodeSortOrder = '-1' | '1';

const mapSortOrderNode = (sort?: SortOrderType): NodeSortOrder | undefined =>
  sort
    ? (
        {
          ascend: '1',
          descend: '-1',
        } as const
      )[sort]
    : undefined;

type NodeSortOrders<T extends Record<string, SortOrderType | undefined>> = {
  [Key in keyof T]?: NodeSortOrder;
};

export const transformSortOrdersNode = <T extends Record<string, SortOrderType | undefined>>(
  sorter: T,
): NodeSortOrders<T> | undefined => {
  const result: NodeSortOrders<T> = {};
  let hasSort = false;

  for (const key in sorter) {
    if (!Object.hasOwn(sorter, key)) {
      continue;
    }

    const mapped = mapSortOrderNode(sorter[key]);

    if (mapped === undefined) {
      continue;
    }

    result[key] = mapped;
    hasSort = true;
  }

  return hasSort ? result : undefined;
};
